import { Component, Input } from '@angular/core';
import { GenericRemovedItem } from '../models/generic-bulk-upsert.model';

@Component({
  selector: 'generic-removed-items-table',
  templateUrl: './removed-items-table.component.html'
})
export class GenericRemovedItemsTableComponent {
  @Input() removed: GenericRemovedItem[] = [];
  
  // Pagination
  currentPage = 1;
  pageSize = 15;

  get pagedItems(): GenericRemovedItem[] {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.removed.slice(start, end);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
  }

  onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.currentPage = 1;
  }
}